import { DatapointIdStandardEnum } from "../api/ux/src";
export const inspectDataDefaultDimensions = [
    DatapointIdStandardEnum.AssetAssetId,
    DatapointIdStandardEnum.FundInvestorId,
    DatapointIdStandardEnum.FundFundId,
    DatapointIdStandardEnum.ManagerManagerId,
    DatapointIdStandardEnum.PortfolioPortfolioId,
    DatapointIdStandardEnum.InstrumentInstrumentId,
    DatapointIdStandardEnum.FundSeriesId
];
export const defaultDimensions = [
    DatapointIdStandardEnum.AssetAssetId,
    DatapointIdStandardEnum.FundFundId,
    DatapointIdStandardEnum.ManagerManagerId,
    DatapointIdStandardEnum.PortfolioPortfolioId,
    DatapointIdStandardEnum.InstrumentInstrumentId,
    DatapointIdStandardEnum.FundInvestorId,
    DatapointIdStandardEnum.FundSeriesId
];
export const datasetNameToDatapointIdMap = new Map([
    ["Asset", DatapointIdStandardEnum.AssetAssetId],
    ["Fund", DatapointIdStandardEnum.FundFundId],
    ["Manager", DatapointIdStandardEnum.ManagerManagerId],
    ["Portfolio", DatapointIdStandardEnum.PortfolioPortfolioId],
    ["Instrument", DatapointIdStandardEnum.InstrumentInstrumentId],
    ["FundSeries", DatapointIdStandardEnum.FundSeriesId]
]);
export var DimensionsSelectionContext;
(function (DimensionsSelectionContext) {
    DimensionsSelectionContext[DimensionsSelectionContext["Default"] = 0] = "Default";
    DimensionsSelectionContext[DimensionsSelectionContext["InspectData"] = 1] = "InspectData";
})(DimensionsSelectionContext || (DimensionsSelectionContext = {}));
export var DatapointGroupingType;
(function (DatapointGroupingType) {
    DatapointGroupingType[DatapointGroupingType["MeasureOnly"] = 0] = "MeasureOnly";
    DatapointGroupingType[DatapointGroupingType["Dimension"] = 1] = "Dimension";
})(DatapointGroupingType || (DatapointGroupingType = {}));
export var CommmonFormatEnum;
(function (CommmonFormatEnum) {
    CommmonFormatEnum["percent"] = "percent";
    CommmonFormatEnum["multiple"] = "multiple";
    CommmonFormatEnum["value"] = "value";
    CommmonFormatEnum["number"] = "number";
    CommmonFormatEnum["currency"] = "currency";
    CommmonFormatEnum["string"] = "string";
    CommmonFormatEnum["amount"] = "amount";
    CommmonFormatEnum["boolean"] = "boolean";
    CommmonFormatEnum["date"] = "date";
    CommmonFormatEnum["esg"] = "esg";
    CommmonFormatEnum["performancePeriod"] = "performancePeriod";
    CommmonFormatEnum["quartile"] = "quartile";
    CommmonFormatEnum["year"] = "year";
    CommmonFormatEnum["area"] = "area";
    CommmonFormatEnum["unit"] = "unit";
    CommmonFormatEnum["entity"] = "entity";
})(CommmonFormatEnum || (CommmonFormatEnum = {}));
